import { URI } from '@/config/config'

export default async ({ rootState }, { creditId }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify({
      creditId
    })
  }

  try {
    const actionResult = await fetch(`${URI}payment/remove-retroactive-register`, opts)
    const resultJson = await actionResult.json()

    if (actionResult.status !== 200) {
      return Promise.reject(resultJson)
    }

    return resultJson.result
  } catch (error) {
    return Promise.reject(error)
  }
}